<template>
  <div class="row">
    <div class="col-lg-12">
      <block-cntr btitle="Tcont Config" style="height: 410px">
        <div class="form-inline">
          <span style="float: left">
            <div class="btn-group open">
              <div
                @click="isShowAddTable = true"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-plus page-tableaction"></i>
              </div>
              <div
                @click="clkEdit()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-edit page-tableaction"></i>
              </div>

              <div
                @click="clkDel()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-trash-o page-tableaction"></i>
              </div>
            </div>
          </span>
        </div>

        <table class="table table-hover table-noneborder-top">
          <thead>
            <tr>
              <th width="40px">
                <input
                  type="checkbox"
                  v-model="isSelectAll"
                  @change="changeSelectAll()"
                  id="idSelectAll"
                />
                <label for="idSelectAll"></label>
              </th>
              <th v-for="(value, key) in title" :key="key" :title="value">
                {{ value }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, index) in tcontTable"
              :key="row.profileid"
              :class="{ 'true:': true }"
              @click="changeSelect(row)"
            >
              <td width="40px">
                <div @click.stop="" v-if="!row.isNew">
                  <input
                    type="checkbox"
                    v-model="row.selected"
                    :id="'idRowSelect' + index"
                  />
                  <label :for="'idRowSelect' + index"></label>
                </div>
              </td>
              <td>
                <div>{{ row.tcontId }}</div>
              </td>
              <td>
                <div>{{ row.dbaProfileId }}</div>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-if="isShowAddTable">
          <dialog-box
            :btitle="'Tcont Edit'"
            @close="isShowAddTable = false"
            style="min-height: 410px"
          >
            <form
              class="form-horizontal"
              name="genform"
              method="post"
              action=""
            >
              <div class="form-group">
                <label class="col-sm-3 control-label" for="tcont">{{
                  title.tcontId
                }}</label>
                <div
                  class="col-sm-5"
                  :class="{ 'has-error': input_para_check(1) }"
                >
                  <input
                    type="text"
                    class="form-control"
                    id="tcont"
                    :disabled="isEditClik"
                    v-model="tcontForm.tcontId"
                    autocomplete="off"
                    placeholder="INTEGER<1-8>"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: input_para_check(1) ? 'block' : 'none',
                    }"
                    >{{ input_para_check(1) }}
                  </small>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label" for="dbaid">{{
                  title.dbaProfileId
                }}</label>
                <div class="col-sm-5">
                  <select
                    class="form-control"
                    id="dbaid"
                    v-model="tcontForm.dbaProfileId"
                  >
                    <option value="" disabled selected style="display: none">
                      please choose..
                    </option>
                    <option
                      v-for="(dba, index) in dbaTable"
                      :key="index"
                      :value="dba.profileId"
                    >
                      {{ dba.profileId + ":" + dba.profileName }}
                    </option>
                  </select>
                </div>
              </div>

              <button
                type="button"
                class="btn btn-primary"
                style="
                  margin-left: 20%;
                  min-width: 77px;
                  color: #fff;
                  background-color: #008b8b;
                  border-color: #008080;
                "
                @click="clkApply()"
              >
                {{ "Apply" }}
              </button>
              <span style="margin-left: 10px">
                <button
                  type="button"
                  class="btn btn-default"
                  style="min-width: 77px"
                  @click="clkCancel()"
                >
                  {{ "Cancel" }}
                </button>
              </span>
            </form>
          </dialog-box>
        </div>
      </block-cntr>
    </div>

    <info-box :ibox="iBox"></info-box>
    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>

<script>
import BlockCntr from "./../components/BlockCntr.vue"
import { get, post } from "@/utils/http.js"
import InfoBox from "./../components/InfoBox.vue"
import DialogBox from "@/components/DialogBox"

export default {
  name: "profileLineTcont",
  components: {
    BlockCntr,
    DialogBox,
    InfoBox,
  },

  props: ["profileId"],

  data() {
    return {
      title: {},
      isShowAddTable: false,
      isEditClik: false,
      iBox: {},
      isSelectAll: false,
      select: [],

      tcontForm: {
        tcontId: "",
        dbaProfileId: "",
      },

      tcontTable: [],

      dbaTable: [],
    }
  },

  created() {
    this.loadtcontInfo()
    this.loaddbaProfile()
  },

  methods: {
    loadtcontInfo() {
      get("profiletcont?profileId=" + this.profileId)
        .then((res) => {
          this.tcontTable = res.data.data
          this.title = res.data.title
        })
        .catch((err) => {
          console.log(err)
        })
    },

    loaddbaProfile() {
      get("profiledba")
        .then((res) => {
          this.dbaTable = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },

    clkCancel() {
      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },

    resetField() {
      var dbaformTmp = {
        tcontId: "",
        dbaProfileId: "",
      }

      this.tcontForm = dbaformTmp
    },

    profileSortFun(a, b) {
      return Number(a.tcontId) - Number(b.tcontId)
    },

    clkApply() {
      var newProfile = {
        profileId: Number(this.profileId),
        tcontId: Number(this.tcontForm.tcontId),
        dbaProfileId: Number(this.tcontForm.dbaProfileId),
        operate: 1,
      }

      if (!this.isEditClik) {
        for (let i = 0; i < this.tcontTable.length; i++) {
          if (this.tcontTable[i].tcontId == newProfile.tcontId) {
            this.showAlertBox(
              "warn",
              "Message",
              "this tcont id has been existed,please choose a new one"
            )
            return
          }
        }
      }

      post("profiletcont", newProfile)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.showAlertBox("info", "Info", "Config successful!")
            this.loadtcontInfo()
            /*if (this.isEditClik) {
              let index = this.select[0]
              this.tcontTable[index] = newProfile
            } else {
              this.tcontTable.push(newProfile)
              this.tcontTable.sort(this.profileSortFun)
            }*/
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          console.log(err)
          this.showAlertBox("critical", "error", err)
        })

      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },

    clkEdit() {
      for (let i = 0; i < this.tcontTable.length; i++) {
        if (this.tcontTable[i].selected) {
          this.tcontForm.tcontId = this.tcontTable[i].tcontId
          this.tcontForm.dbaProfileId = this.tcontTable[i].dbaProfileId
          this.isShowAddTable = true
          this.isEditClik = true
          this.select[0] = i
          return
        }
      }
    },

    clkDel() {
      var errflag = 0
      var del = []
      var i
      var id = []
      var newProfile = {
        profileId: 0,
        tcontId: 1,
        operate: 2,
      }

      for (i = 0; i < this.tcontTable.length; i++) {
        if (this.tcontTable[i].selected) {
          newProfile.profileId = Number(this.profileId)
          newProfile.tcontId = Number(this.tcontTable[i].tcontId)
          del.push(post("profiletcont", newProfile))
          id.push(this.tcontTable[i].tcontId)
        }
      }

      if (del.length == 0) {
        return
      }

      Promise.all(del)
        .then((res) => {
          res.forEach((element, index) => {
            if (
              element.data == undefined ||
              element.data.code === undefined ||
              element.data.code === 0
            ) {
              for (i = 0; i < this.tcontTable.length; i++) {
                if (this.tcontTable[i].tcontId == id[index]) {
                  this.tcontTable.splice(i, 1)
                  break
                }
              }
            } else {
              this.showAlertBox("warn", "Message", element.data.msg)
              errflag = 1
            }
          })
          if (errflag === 0)
            this.showAlertBox("info", "Info", "Delete successful!")
        })

        .catch((err) => {
          console.log(err)
          this.showAlertBox("critical", "error", err)
        })
    },

    changeSelectAll() {
      for (let i = 0; i < this.tcontTable.length; i++) {
         if (this.isSelectAll) {
          this.$set(this.tcontTable[i], "selected", true)
        } else {
          this.$set(this.tcontTable[i], "selected", false)
        }
      }
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },

    changeSelect(row) {
      console.log(row)
      if (row.selected == undefined) {
        this.$set(row, "selected", true)
      } else row.selected = !row.selected
    },

    input_para_check(value) {
      if (value == 1 || value == 0) {
        if (this.tcontForm.tcontId != "") {
          let tcontId = Number(this.tcontForm.tcontId)
          if (!isNaN(tcontId)) {
            if (tcontId < 1 || tcontId > 8)
              return "tcont id must be in range 1-8"
          } else return "tcont id must be in range 1-8"
        }
      }
      return null
    },
  },

  filters: {
    capitalize: function (value) {
      if (value == "0") return "Sn"
      else if (value == "1") return "Pw"
      else if (value == "2") return "Sn+Pw"
      else if (value == "3") return "Loid"
      else if (value == "4") return "LoidPw"
      else if (value == "5") return "Loid+LoidPw"
      else return value
    },
  },
}
</script>

<style>
.table_edit {
  position: absolute;
  top: 20%;
  left: 20%;
  z-index: 1;
  width: 50%;
}
</style>